"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

/** Sonner's own offsets (24px, 16px on a phone), kept clear of the notch and home indicator (`viewport-fit=cover`). */
const safeOffset = (edge: string, gap: number) =>
  `max(${gap}px, env(safe-area-inset-${edge}))`;
const toastOffset = (gap: number) => ({
  top: safeOffset("top", gap),
  right: safeOffset("right", gap),
  bottom: safeOffset("bottom", gap),
  left: safeOffset("left", gap),
});

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      offset={toastOffset(24)}
      mobileOffset={toastOffset(16)}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
